import React from 'react';
import CommonPageHeader from '../../../components/CommonPageHeader/CommonPageHeader';
import PageHelmet from '../../../components/shared/PageHelmet';
import MainFooter from '../../../components/MainFooter/MainFooter';
import NavHeader from '../../../components/NavHeader/NavHeader';
import KeyFeatures from '../KeyFeatures/KeyFeatures';
import OurApproach from '../../Home/OurApproach/OurApproach';
import AdditionalServices from '../AdditionalServices/AdditionalServices';
import { Cone, ShieldCheck, CircleGauge, ChartArea, FileJson, CalendarSync, Puzzle, Globe, RefreshCcwDot } from 'lucide-react';
import OurExpertise from '../../../components/OurExpertise/OurExpertise';
import { Link } from 'react-router-dom';

const OurExpertiseData = [
    {
        id: 1,
        title: "Comprehensive Testing Coverage",
        icon: <Globe size="64" strokeWidth='1' />,
        content: "Our team offers end-to-end testing services, covering everything from functional testing and regression testing to performance, security, and usability. We ensure that no aspect of your application is overlooked, providing thorough validation of every feature."
    },
    {
        id: 2,
        title: "Automated Testing Solutions",
        icon: <RefreshCcwDot size="64" strokeWidth='1' />,
        content: "We leverage advanced automation tools and frameworks to speed up the testing process, reduce human error, and improve the efficiency of repetitive tasks. Our automated testing ensures consistent results and accelerates time-to-market."
    }
]

const KeyFeaturesData = [
    {
        id: 1,
        title: "Functional Testing",
        icon: <FileJson size="42" strokeWidth='1' />,
        content: "Validate your software’s functionality and workflows to ensure they align with your design and purpose."
    },
    {
        id: 2,
        title: "Regression Testing",
        icon: <ChartArea size="42" strokeWidth='1' />,
        content: "Keep your software stable by identifying and resolving issues introduced during updates or new feature releases."
    },
    {
        id: 3,
        title: "Performance Testing",
        icon: <CircleGauge size="42" strokeWidth='1' />,
        content: "Evaluate speed, scalability, and reliability to enhance the user experience and avoid potential bottlenecks."
    },
    {
        id: 4,
        title: "Security Testing",
        icon: <ShieldCheck size="42" strokeWidth='1' />,
        content: "Identify vulnerabilities and safeguard your application against data breaches and cyber threats."
    },
]

const AdditionalServicesData = [
    {
        id: 1,
        title: "Usability Testing",
        icon: <Cone size="54" strokeWidth='1' />,
        content: "Improve user satisfaction with intuitive interfaces and seamless interactions."
    },
    {
        id: 2,
        title: "Compatibility Testing",
        icon: <Puzzle size="54" strokeWidth='1' />,
        content: "Ensure flawless performance across multiple devices, browsers, and operating systems."
    },
    {
        id: 3,
        title: "Automation Testing",
        icon: <CalendarSync size="54" strokeWidth='1' />,
        content: "Accelerate the testing process using advanced tools and frameworks for efficiency and cost-effectiveness."
    }
]

const OurApproachData = [
    {
        id: 1,
        title: <h3><Link to="/">Discovery</Link></h3>,
        img: "assets/img/project/discover_icon_white.svg",
        content: "Understand your goals through collaborative sessions."
    },
    {
        id: 2,
        title: <h3><Link to="/">Design</Link></h3>,
        img: "assets/img/project/design_icon_white.svg",
        content: "Deliver wireframes, prototypes, and scalable architectures focused on usability and performance."
    },
    {
        id: 3,
        title: <h3><Link to="/">Development</Link></h3>,
        img: "assets/img/project/develop_icon_white.svg",
        content: "Deliver wireframes, prototypes, and scalable architectures focused on usability and performance."
    },
    {
        id: 4,
        title: <h3><Link to="/">Quality Assurance</Link></h3>,
        img: "assets/img/project/define_icon_white.svg",
        content: "Ensure flawless functionality on all devices and platforms."
    },
    {
        id: 5,
        title: <h3><Link to="/">Launch & Support</Link></h3>,
        img: "assets/img/project/deliver_icon_white.svg",
        content: "Seamless deployment, app store submissions, and ongoing maintenance."
    }
]
const bgColors = ["#006ce0", "#001133", "#006ce0", "#001133", "#006ce0"];

const SoftwareTesting = () => {
    return (
        <>
            <PageHelmet
                pageTitle="Software Testing Services"
                description="Functional, regression, performance, and security testing services from Harsoft Solutions, a software development company ensuring reliable, high-quality releases."
                keywords="Software Testing, QA Services, Software Development Company"
                path="/SoftwareTesting"
            />

            <NavHeader />
            <main>
                <CommonPageHeader title="Software Testing" subtitle="Software Testing" />
                <OurExpertise OurExpertiseData={OurExpertiseData} title="Our Expertise" subtitle="Ensuring Quality and Reliability" content="Delivering flawless software is non-negotiable in today’s competitive landscape. At Harsoft Solutions, we offer meticulous software testing services to ensure your applications are reliable, secure, and high-performing." />
                <KeyFeatures KeyFeaturesData={KeyFeaturesData} />
                <AdditionalServices AdditionalServicesData={AdditionalServicesData} img="assets/img/expart/expart-1.jpg" />
                <OurApproach OurApproachData={OurApproachData} title="Our Process" bgColors={bgColors} />
            </main>
            <MainFooter />
        </>
    );
};

export default SoftwareTesting;
